import React from 'react';
import { Button } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { getSmartLabelClassName } from '../../../../../utils/labelWidthUtils';
import DateRangeFilterItem from '../../../../delivery/components/DateRangeFilterItem';

export interface DeliveryCompletedSummaryFilters {
    dateRange?: [Dayjs, Dayjs] | null;
    hubIds?: number[] | null;
    warehouseIds?: number[] | null;
    oneSortingCodes?: string[] | null;
    twoSortingCodes?: string[] | null;
    threeSortingCodes?: string[] | null;
    dspIds?: number[] | null;
    driverIds?: number[] | null;
}

interface Props {
    filters: DeliveryCompletedSummaryFilters;
    onFiltersChange: (next: Partial<DeliveryCompletedSummaryFilters>) => void;
    showActions?: boolean; // 是否显示按钮区（默认显示）
    onReset?: () => void; // 重置回调（可选，默认使用内部重置逻辑）
}

const DeliveryCompletedSummaryFilter: React.FC<Props> = ({
    filters,
    onFiltersChange,
    showActions = true,
    onReset
}) => {
    const { t } = useTranslation();

    const labelDateRange = String(t('wms.delivery.deliveryCompletedSummary.filters.dateRange'));
    const colLabels = [labelDateRange];

    const handleReset = () => {
        onFiltersChange({
            dateRange: [dayjs().subtract(7, 'day'), dayjs()] // 重置为默认一周
        });
    };

    return (
        <div>
            <div className="min-w-0 max-w-full lg:max-w-[520px]">
                <DateRangeFilterItem
                    label={labelDateRange}
                    value={
                        filters.dateRange
                            ? [filters.dateRange[0].format('YYYY/MM/DD'), filters.dateRange[1].format('YYYY/MM/DD')]
                            : null
                    }
                    onChange={(dates) => {
                        if (!dates || !dates[0] || !dates[1]) {
                            onFiltersChange({ dateRange: null });
                            return;
                        }
                        onFiltersChange({
                            dateRange: [dayjs(dates[0], 'YYYY/MM/DD'), dayjs(dates[1], 'YYYY/MM/DD')] as [Dayjs, Dayjs]
                        });
                    }}
                    spanClassName={getSmartLabelClassName(colLabels)}
                    className="[&_.ant-picker-range]:!w-[280px] [&_.ant-picker-range]:max-w-full"
                />
            </div>

            {showActions && (
                <div className="mt-3 flex justify-end items-center gap-2">
                    <Button type="default" onClick={onReset || handleReset} className="w-auto min-w-24">
                        <span className="font-bold">{t('wms.delivery.deliveryCompletedSummary.filters.reset')}</span>
                    </Button>
                </div>
            )}
        </div>
    );
};

export default DeliveryCompletedSummaryFilter;

